import React from 'react';

import { IButtonProps } from './types';
import {
  StyledButton,
  IconBefore,
  IconAfter,
  ButtonChildren,
  LoadingContainer,
} from './styled';

import BeatLoader from 'react-spinners/BeatLoader';
import { useTheme, ITheme } from '@unfold/theme';
import noop from 'lodash.noop';
import { ButtonTheme } from './theme';

export const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
  (
    {
      appearance = 'default',
      children,
      isLoading = false,
      isDisabled = false,
      onClick,
      ...props
    },
    ref
  ) => {
    const currentTheme: ITheme = useTheme();
    return (
      <StyledButton
        ref={ref}
        data-testid={props.testId}
        appearance={appearance}
        isDisabled={isDisabled}
        onClick={isDisabled ? noop : onClick}
        {...props}
      >
        {isLoading ? (
          <LoadingContainer
            data-testid={props.testId ? `${props.testId}__loader` : null}
          >
            <BeatLoader
              color={ButtonTheme[appearance][currentTheme.name].color}
              size="5px"
            />
          </LoadingContainer>
        ) : (
          <>
            {props.iconBefore && (
              <IconBefore
                data-testid={
                  props.testId ? `${props.testId}__iconBefore` : null
                }
              >
                {props.iconBefore}
              </IconBefore>
            )}
            <ButtonChildren>{children}</ButtonChildren>
            {props.iconAfter && (
              <IconAfter
                data-testid={props.testId ? `${props.testId}__iconAfter` : null}
              >
                {props.iconAfter}
              </IconAfter>
            )}
          </>
        )}
      </StyledButton>
    );
  }
);

Button.displayName = 'UnfoldButton';
